import React, { useState, useEffect } from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { useGroupList } from "hooks/product/useProduct";
import { useTranslation } from "react-i18next";

const FilterTable = ({ productListParams, setProductListParams }) => {
  const { t } = useTranslation(["product"]);
  const [isGroupFilter, setIsGroupFilter] = useState(false);
  const [selectedGroupFilter, setSelectedGroupFilter] = useState(`${t("all")}`);
  const [groupsFilter, setGroupsFilter] = useState([]);

  const [isStatusFilter, setIsStatusFilter] = useState(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState(
    `${t("all")}`
  );
  const [statusFilter, setStatussFilter] = useState([
    {
      name: `${t("actions.active")}`,
      value: "O",
    },
    {
      name: `${t("actions.un_active")}`,
      value: "C",
    },
  ]);

  const handleSelectGroupFilter = group => {
    if (typeof group === "string") {
      setSelectedGroupFilter(group);
    } else {
      setSelectedGroupFilter(`${t("all")}`);
    }

    setProductListParams(prev => ({
      ...prev,
      columnFilter: {
        ...prev.columnFilter,
        "filter[group]": group,
      },
    }));
  };
  const handleSelectStatusFilter = stt => {
    if (typeof stt === "object") {
      setSelectedStatusFilter(stt.name);
    } else {
      setSelectedStatusFilter(`${t("all")}`);
    }
    setProductListParams(prev => ({
      ...prev,
      columnFilter: {
        ...prev.columnFilter,
        "filter[record_status]": stt?.value,
      },
    }));
  };

  const handleVisibleFilter = visible => {
    setProductListParams(prev => ({
      ...prev,
      columnFilter: {
        ...prev.columnFilter,
        "filter[visible]": visible ? 1 : 0,
      },
    }));
  };

  const { data: groups, refetch: refreshGroups } = useGroupList(res => {
    setGroupsFilter(res);
  });

  useEffect(() => {
    refreshGroups();
  }, []);
  return (
    <div className="d-flex flex-row justify-content-start align-items-center gap-2">
      <div className="GroupFilter">
        <Dropdown
          isOpen={isGroupFilter}
          toggle={() => setIsGroupFilter(!isGroupFilter)}
        >
          <DropdownToggle className="btn primary-btn w-100" caret>
            {t("group")}
            {selectedGroupFilter && <span>:&nbsp;{selectedGroupFilter}</span>}
            <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <DropdownMenu className="w-100">
            <DropdownItem
              key={`group-all`}
              onClick={() => handleSelectGroupFilter([])}
            >
              {t("all")}
            </DropdownItem>
            {groupsFilter?.map((group, index) => (
              <DropdownItem
                key={`group-${index}`}
                onClick={() => handleSelectGroupFilter(group)}
              >
                {group}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="StatusFilter">
        <Dropdown
          isOpen={isStatusFilter}
          toggle={() => setIsStatusFilter(!isStatusFilter)}
        >
          <DropdownToggle className="btn primary-btn w-100" caret>
            {t("status")}
            {selectedStatusFilter && <span>:&nbsp;{selectedStatusFilter}</span>}
            <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <DropdownMenu className="w-100">
            <DropdownItem
              key={`status-all`}
              onClick={() => handleSelectStatusFilter()}
            >
              {t("all")}
            </DropdownItem>
            {statusFilter?.map((stt, index) => (
              <DropdownItem
                key={`group-${index}`}
                onClick={() => handleSelectStatusFilter(stt)}
              >
                {stt.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
      <Button
        color={
          productListParams.columnFilter["filter[visible]"] === 1
            ? "warning"
            : "secondary"
        }
        onClick={() =>
          handleVisibleFilter(
            productListParams.columnFilter["filter[visible]"] !== 1
          )
        }
      >
        {productListParams.columnFilter["filter[visible]"] === 1
          ? "Hiển thị"
          : "Không hiển thị"}
      </Button>
    </div>
  );
};

export default FilterTable;
